module.exports = __webpack_public_path__ + "static/media/AIR_HOUSE_TYPE86_TEMPLATE.83b8d9f3.csv";